import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  const positive = ['Tienes un perro y quieres prepararle comidas o premios caseros.', 'No sabes exactamente qué ingredientes son seguros para perros.', 'Buscas una guía simple, visual y fácil de aplicar desde hoy.', 'Quieres organizarte mejor para cocinarle a tu mascota.', 'Te preocupa la seguridad alimentaria de tu perro.', 'Quieres tener herramientas prácticas imprimibles para cocinar con más calma.', 'Eres principiante en cocina casera para mascotas.'];
  const negative = ['Buscas un plan nutricional veterinario completo y personalizado.', 'Tu perro tiene una condición médica grave que requiere dieta especializada.', 'Quieres reemplazar completamente la alimentación de tu perro sin consultar a un veterinario.', 'Buscas un producto físico enviado a tu domicilio.'];
  return <section className="py-20 px-4 bg-white" data-id="element-221">
      <div className="max-w-5xl mx-auto" data-id="element-222">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-223">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-green/10 rounded-3xl p-8 border border-brand-green/20" data-id="element-224">
            <h2 className="text-2xl font-bold text-brand-navy mb-8 flex items-center gap-3" data-id="element-225">
              <span className="bg-brand-green text-white p-2 rounded-full" data-id="element-226">
                <CheckCircle2 className="w-6 h-6" data-id="element-227" />
              </span>
              Este pack es para ti si...
            </h2>
            <ul className="space-y-4" data-id="element-228">
              {positive.map((item, index) => <li key={index} className="flex items-start gap-3 text-gray-700" data-id="element-229">
                  <CheckCircle2 className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-230" />
                  <span data-id="element-231">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-red-50 rounded-3xl p-8 border border-red-100" data-id="element-232">
            <h2 className="text-2xl font-bold text-brand-navy mb-8 flex items-center gap-3" data-id="element-233">
              <span className="bg-red-500 text-white p-2 rounded-full" data-id="element-234">
                <XCircle className="w-6 h-6" data-id="element-235" />
              </span>
              Este pack NO es para ti si...
            </h2>
            <ul className="space-y-4" data-id="element-236">
              {negative.map((item, index) => <li key={index} className="flex items-start gap-3 text-gray-700" data-id="element-237">
                  <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-238" />
                  <span data-id="element-239">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}